<script lang="ts">
  import Settings from '$lib/components/settings/Settings.svelte';
</script>

<svelte:head>
  <title>Einstellungen</title>
</svelte:head>

<Settings />
